<template>
    <div id="simNotice">
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="所属代理商：">
                <el-input v-model.trim="searchForm.agentName"  @keyup.enter.native="getNoticeList" clearable></el-input>
            </el-form-item>
            <el-form-item label="商品名称：">
                <el-input v-model.trim="searchForm.shopName"  @keyup.enter.native="getNoticeList" clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getNoticeList" clearable></el-input>
            </el-form-item>
            <el-form-item label="订单号：">
                <el-input v-model.trim="searchForm.orderNo" @keyup.enter.native="getNoticeList" clearable></el-input>
            </el-form-item>
            <el-form-item label="第三方单号：">
                <el-input v-model.trim="searchForm.payNo" @keyup.enter.native="getNoticeList" clearable></el-input>
            </el-form-item>
             <el-form-item label="订单状态：">
                <el-select v-model="searchForm.payState" clearable>
                    <el-option v-for="item in orderState" :key="item.description" :label="item.description" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="下单时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
              <el-form-item label="输入验证：">
                <el-input v-model="searchForm.myPass" @keyup.enter.native="getChangeCardListHandler" clearable></el-input>
            </el-form-item>
             <el-form-item class="btnArea">
                <el-button type="primary" @click="getNoticeList">搜索查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column label="ICCID号" width="180px">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="package_name" label="商品名称" ></el-table-column>
            <el-table-column prop="price" label="价格"></el-table-column>
            <el-table-column prop="stateName" label="状态" ></el-table-column>
             <el-table-column prop="shopSize" label="购买数量" ></el-table-column>
              <el-table-column prop="remark" label="用户备注" ></el-table-column>
             <el-table-column prop="agentSeeName" label="代理商可见" ></el-table-column>
            <el-table-column prop="agent_name" label="代理商名称" ></el-table-column>
             <el-table-column prop="commission" label="代理商分润" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间"></el-table-column>
            <el-table-column prop="displacedRemark" label="备注-快递单号"></el-table-column>
            <el-table-column label="操作" width="250px" >
                <template v-slot="scope">
                    <el-button v-show="scope.row.pay_state==1"  type="text" @click="handleCopy(scope.$index,scope.row)">复制收件地址</el-button>
                    <el-button v-show="scope.row.pay_state==1||scope.row.pay_state==2"  type="text" @click="backuserFlag(scope.row)">退款</el-button>
                    <el-button v-show="scope.row.pay_state==1||scope.row.pay_state==2"  type="text" @click="backuserFlag1(scope.row)">处理发货</el-button>
                </template>    
            </el-table-column>
        </el-table>
        
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>    

        <el-dialog :append-to-body="true"  title="退款" :visible.sync="backTrue"  width="600px"  class="notifyDetail" :close-on-click-modal="false" @close="cancel()">
            <el-form ref="backInfo" :model="backInfo"  label-width="140px">
                 <el-form-item label="退款金额" prop="content">
                    <el-input v-model="backInfo.price"  clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel()">取 消</el-button>
                <el-button type="primary" @click="backuser()">确 定</el-button>
            </div>
        </el-dialog>      
        
        <el-dialog :append-to-body="true"  title="处理发货" :visible.sync="displace"  width="600px"  class="notifyDetail" :close-on-click-modal="false" @close="cancel()">
            <el-form ref="displaceRemark" :model="displaceRemark"  label-width="140px">
                 <el-form-item label="快递单号或备注" prop="displaceRemark">
                    <el-input v-model="displaceRemark"  clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel()">取 消</el-button>
                <el-button type="primary" @click="backuser1()">确 定</el-button>
            </div>
        </el-dialog>        

    </div>
</template>

<script>
import common from '@/utils/common.js'
export default {
    data(){
        return { 
            displaceRemark:'',
            displace:false, 
            backTrue:false, 
            curredId:'',
            backInfo:{
                id:'',
                price:''
            },
            searchForm: {
                agentName: '',
                supplierCode: '',
                iccid: '',
                orderNo: '',
                investType: '',
                time: '',
                payState: '',
                isNextMonth: null,
                createType: '',
                sendState:'',
                payNo: null,
                shopName:'',
                myPass:''
            },
            orderState:[
                {'code':0,'description':'待付款'},
                {'code':1,'description':'待发货'},
                {'code':2,'description':'已发货'},
               {'code':3,'description':'已退款'},
              {'code':4,'description':'退款中'}
            ],
        linkStateOption:[
            {'id':3,'name':'跳转第三方链接'},
              {'id':4,'name':'跳转APP内部链接'}
        ],
         stateOption:[
            {'id':1,'name':'正常'},
              {'id':2,'name':'禁用'}
        ],
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },    

            detailVisible:false,
            detail:{
                title:null,
                content: null,
                createTime: null,
            },   

            branchSupplierOption: [],//运营商字典
            editVisibale: false,
            editForm:{
                id: null,
                title: null,
                content: null,
                linkUrl:null,
                state:null,
                supplierCodes: [],
                supplierNames: "",
                linkState:null
            },
               goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
         goToInfoPage(row){
            this.$store.commit('menu/setFromPage', 'cardList');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardInfoMenu').click();
        },
            editRules: {
                title: { required: true, message: '请输入标题', trigger: 'blur' },
                content: {required: true, message: '请输入内容', trigger: 'blur'}
            },

        }
    },
    methods: {
     handleCopy(index,row){
      this.copyData = row.supplier_name
      this.copy(this.copyData)
    },
    copy(data){
        let url = data;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        console.log(oInput.value)
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
          message: '复制成功',
          type: 'success'
        });
        oInput.remove()
      },
        getNoticeList($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);        
            common.sysRequest('app/pc/app/shop/order', data, 'post').then(res=>{
                common.listCallback(this, res, 'tbpg');
            });
        },
        backuserFlag(row){
            this.backInfo.id=row.id;
            this.backTrue=true;
        },
         backuserFlag1(row){
            this.curredId=row.id;
            this.displace=true;
        },
        backuser(row){
        this.backInfo.price= this.backInfo.price*100;
        common.sysRequest('app/pc/app/return/order', this.backInfo, 'post').then(res=>{
                if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.getNoticeList();
                        }else{
                           this.$message.error(res.data.message); 
                 }
               this.cancel();
            });
        },
         backuser1(row){
       var data={
           id:this.curredId,
           disposeRemark:this.displaceRemark
       }
        common.sysRequest('app/pc/app/displaced/order', data, 'post').then(res=>{
                if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.getNoticeList();
                        }else{
                           this.$message.error(res.data.message); 
                 }
               this.cancel();
            });
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getNoticeList();
        },
        handleCurrentChange(val){            
            this.tbpg.currentPage = val;
            this.getNoticeList();
        },

        showDetail(data){
            this.detail = data;
            this.detailVisible = true;
        },

        showEditDialog(data){
            if(data){
                this.editForm = data;
                this.editForm.supplierCodes = Array.isArray(data.supplierCodes)?data.supplierCodes:data.supplierCodes.split("，");
            }else{
                this.editForm = {
                    id: null,
                    title: null,
                    content: null,
                    linkUrl: null,
                    supplierCodes: [],
                    supplierNames: "",
                };
            }
            this.editVisibale = true;
        },

        chooseAll(){
            let val = [];
            for(let i in this.branchSupplierOption){
                val.push(this.branchSupplierOption[i].id);
            }
            this.editForm.supplierCodes = val;
        },
        cancelChooseAll(){
            this.editForm.supplierCodes = [];
        },

        confirmHandler(){
            this.$refs.editForm.validate(valid => {
                if(valid) {
                    let d = this.editForm;
                    d.supplierNames = "";
                    for(let j=0; j<d.supplierCodes.length; j++){
                        for(let i=0; i<this.branchSupplierOption.length; i++){
                            if(this.branchSupplierOption[i].id == d.supplierCodes[j]){
                                d.supplierNames += this.branchSupplierOption[i].name + '(' + this.branchSupplierOption[i].alias + ')，';
                                break;
                            }
                        }
                    }
                    d.supplierCodes = d.supplierCodes.join("，");
                    if(d.supplierNames.lastIndexOf('，') == d.supplierNames.length-1){
                        d.supplierNames = d.supplierNames.substring(0, d.supplierNames.length-1);
                    }
                    let path = "app/pc/notice/add";
                    if(d.id && d.id!=""){
                       path =  "app/pc/notice/update"
                    }
                    common.sysRequest(path, d, 'post').then(res => {
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.cancel();
                            this.getNoticeList();
                            
                        }else{
                           this.$message.error(res.data.message); 
                        }
                    })
                }
            });
        },

        cancel(){
            this.editForm = {
                id: null,
                title: null,
                content: null,
                linkUrl: null,
                supplierCodes: [],
                supplierNames: "",
            };
            this.backInfo={
                id:null,
                price:null
            }
            this.editVisibale = false;
            this.backTrue=false;
            this.displace=false;
        },
    },
    created(){
        this.getNoticeList();
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
    }
}
</script>

<style lang="less" scoped>
    .lineInDialog{
        label{
            width: 120px;
            font-weight: bold;
        }
    }
</style>

